(() => {
  const handles = new Set([
    'watches',
    'breitling-watches',
    'tag-heuer',
    'tudor-watches',
    'omega-watches',
    'grand-seiko-watches',
    'norqain',
    'longines-watches',
    'rado-watches',
    'mido-watches',
    'hamilton-watches',
    'tissot-watches',
      'corum-watches'
    ]);
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const collectionIndex = pathParts.indexOf('collections');
  const handle = collectionIndex >= 0 ? pathParts[collectionIndex + 1] : '';
  if (!handles.has(handle)) return;

  document.documentElement.classList.add('gtj-watch-collection');

  const desktopHover = window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)');

  const taxonomyFilters = [
    {
      key: 'movement',
      name: 'filter.p.m.custom.movement_type',
      ariaLabel: 'Filter watches by movement',
      order: ['Automatic', 'Manual-Wind', 'Quartz', 'Solar', 'Spring Drive', 'Smart'],
      classify(label) {
        const value = normalize(label);
        if (/spring\s*drive/.test(value)) return 'Spring Drive';
        if (/solar/.test(value)) return 'Solar';
        if (/quartz|superquartz/.test(value)) return 'Quartz';
        if (/automatic|self[- ]?winding|\bauto\.?\b/.test(value)) return 'Automatic';
        if (/manual|hand[- ]?wound|hand[- ]?wind|wound/.test(value)) return 'Manual-Wind';
        if (/smart|connected/.test(value)) return 'Smart';
        if (/mechanical/.test(value)) return 'Manual-Wind';
        return null;
      }
    },
    {
      key: 'dial',
      name: 'filter.p.m.custom.dial',
      ariaLabel: 'Filter watches by dial colour',
      order: [
        'Black', 'Blue', 'Brown', 'Champagne/Gold', 'Green', 'Grey/Silver',
        'Mother of Pearl', 'Multicolour', 'Orange', 'Pink', 'Purple',
        'Red/Burgundy', 'Skeleton/Openworked', 'White'
      ],
      classify: classifyDial
    }
  ];

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function unique(values) {
    return values.filter((value, index, array) => array.indexOf(value) === index);
  }

  function classifyDial(label) {
    const value = normalize(label).replace(/balck/g, 'black').replace(/turquise/g, 'turquoise');
    if (!value || value === 'n/a') return null;
    if (/multicolou?r|colourful|colorful|world map|rainbow/.test(value)) return 'Multicolour';

    const rhodiumColour = value.match(/rhodium[- ]+(black|blue|red)/);
    if (rhodiumColour) {
      return rhodiumColour[1] === 'black' ? 'Black' :
        rhodiumColour[1] === 'blue' ? 'Blue' : 'Red/Burgundy';
    }

    const colours = [
      { label: 'Black', pattern: /\bblack\b/ },
      { label: 'Blue', pattern: /\b(turquoise|teal|aqua|ice blue|light blue|midnight blue|blue)\b/ },
      { label: 'Brown', pattern: /\b(chocolate|taupe|brown|bronze)\b/ },
      { label: 'Champagne/Gold', pattern: /\b(beige|champagne|cream|ivory|gilt|yellow|gold)\b/ },
      { label: 'Green', pattern: /\bgreen\b/ },
      { label: 'Grey/Silver', pattern: /\b(gunmetal|charcoal|anthracite|rhodium|platinum|grey|gray|silver)\b/ },
      { label: 'Orange', pattern: /\borange\b/ },
      { label: 'Pink', pattern: /\b(salmon|pink)\b/ },
      { label: 'Purple', pattern: /\b(purple|lavender)\b/ },
      { label: 'Red/Burgundy', pattern: /\b(burgundy|red)\b/ },
      { label: 'White', pattern: /\bwhite\b/ }
    ];

    const firstColour = colours
      .map((colour) => {
        const match = value.match(colour.pattern);
        return match ? { label: colour.label, index: match.index } : null;
      })
      .filter(Boolean)
      .sort((a, b) => a.index - b.index)[0];

    if (firstColour) return firstColour.label;
    if (/mother[- ]?(?:of[- ]?)?pearl/.test(value)) return 'Mother of Pearl';
    if (/transparent|skeleton|openworked/.test(value)) return 'Skeleton/Openworked';
    return null;
  }

  function nativeLabel(input) {
    const value = String(input.value || '').trim();
    if (value && !/^gid:\/\/shopify\/FilterSettingGroup\//.test(value)) return value;

    const row = input.closest('li') || input.closest('label') || input.parentElement;
    return String(row ? row.textContent : '')
      .replace(/\s*\(\d+\)\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hydrateHoverImages(root = document) {
    if (!desktopHover.matches) return;
    root.querySelectorAll('template.gtj-watch-hover-template').forEach((template) => {
      const host = template.closest('[data-gtj-watch-hover]');
      if (!host || host.dataset.gtjHydrated === 'true') return;
      host.appendChild(template.content.cloneNode(true));
      host.dataset.gtjHydrated = 'true';
      template.remove();
    });
  }

  function hideRedundantFilters(root = document) {
    root.querySelectorAll('div.collection-sidebar__group, div[class^="collection-sidebar__group--"]').forEach((group) => {
      const heading = normalize(group.querySelector('.collapsible-trigger')?.textContent || '');
      const isGender = Boolean(group.querySelector('input[name="filter.p.m.custom.gender"]'));
      const isRedundant = isGender || heading === 'brand' || heading === 'category';
      if (!isRedundant) return;

      group.classList.add(isGender ? 'gtj-gender-filter-group' : 'gtj-redundant-filter-group');
      group.hidden = true;
      group.setAttribute('aria-hidden', 'true');
    });
  }

  function taxonomyGroupForValue(groups, value) {
    return groups.find((group) => group.values.indexOf(value) !== -1);
  }

  function applyTaxonomySelection(list, config) {
    let values = [];
    list.querySelectorAll('.gtj-taxonomy-filter__checkbox:checked').forEach((checkbox) => {
      values = values.concat(checkbox.gtjTaxonomyValues || []);
    });

    const url = new URL(window.location.href);
    url.searchParams.delete(config.name);
    unique(values).forEach((value) => url.searchParams.append(config.name, value));
    url.searchParams.delete('page');
    document.documentElement.classList.add('gtj-taxonomy-filter-loading');
    window.location.assign(url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : '') + url.hash);
  }

  function hrefWithoutTaxonomyGroup(config, groups, group) {
    const selected = new URL(window.location.href).searchParams.getAll(config.name);
    const remaining = selected.filter((value) => {
      const selectedGroup = taxonomyGroupForValue(groups, value);
      return !selectedGroup || selectedGroup.label !== group.label;
    });
    const url = new URL(window.location.href);
    url.searchParams.delete(config.name);
    unique(remaining).forEach((value) => url.searchParams.append(config.name, value));
    url.searchParams.delete('page');
    return url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : '') + url.hash;
  }

  function enhanceActiveTaxonomyTags(config, groups) {
    const selected = new URL(window.location.href).searchParams.getAll(config.name);
    if (!selected.length) return;

    const selectedGroups = groups.filter((group) =>
      selected.some((value) => group.values.indexOf(value) !== -1)
    );

    document.querySelectorAll('.tag-list--active-tags').forEach((list) => {
      list.querySelectorAll(`a[href*="${config.name}"]`).forEach((link) => {
        const tag = link.closest('li') || link.parentNode;
        if (tag) {
          tag.hidden = true;
          tag.classList.add('gtj-taxonomy-filter__native-active-tag');
        }
      });

      list.querySelectorAll(`.gtj-taxonomy-filter__active-tag--${config.key}`).forEach((tag) => tag.remove());
      selectedGroups.forEach((group) => {
        const item = document.createElement('li');
        item.className = `tag tag--remove gtj-taxonomy-filter__active-tag gtj-taxonomy-filter__active-tag--${config.key}`;

        const link = document.createElement('a');
        link.className = 'btn btn--small';
        link.href = hrefWithoutTaxonomyGroup(config, groups, group);
        link.setAttribute('aria-label', `Remove ${group.label} ${config.key} filter`);
        link.appendChild(document.createTextNode(group.label));

        const remove = document.createElement('span');
        remove.className = 'gtj-taxonomy-filter__active-remove';
        remove.setAttribute('aria-hidden', 'true');
        remove.textContent = '×';
        link.appendChild(remove);
        item.appendChild(link);
        list.appendChild(item);
      });
    });
  }

  function buildTaxonomyFilter(group, config) {
    const enhancedKey = `gtj${config.key[0].toUpperCase()}${config.key.slice(1)}Enhanced`;
    if (group.dataset[enhancedKey] === 'true') return;

    const nativeInputs = Array.from(
      group.querySelectorAll(`input[type="checkbox"][name="${config.name}"]`)
    );
    if (!nativeInputs.length) return;

    const grouped = new Map();
    nativeInputs.forEach((input) => {
      const category = config.classify(nativeLabel(input));
      if (!category) return;
      if (!grouped.has(category)) grouped.set(category, []);
      grouped.get(category).push(input.value);
    });

    const selected = new URL(window.location.href).searchParams.getAll(config.name);
    const groups = config.order
      .filter((label) => grouped.has(label))
      .map((label) => ({ label, values: unique(grouped.get(label)) }));
    if (!groups.length) return;

    const nativeList = nativeInputs[0].closest('ul');
    const mount = nativeList ? nativeList.parentNode : group.querySelector('.collapsible-content__inner') || group;
    if (nativeList) {
      nativeList.hidden = true;
      nativeList.setAttribute('aria-hidden', 'true');
      nativeList.classList.add('gtj-taxonomy-filter__native');
    } else {
      nativeInputs.forEach((input) => {
        const row = input.closest('li') || input.parentNode;
        if (row) row.hidden = true;
      });
    }

    const list = document.createElement('ul');
    list.className = `gtj-taxonomy-filter gtj-taxonomy-filter--${config.key}`;
    list.setAttribute('aria-label', config.ariaLabel);

    groups.forEach((taxonomyGroup) => {
      const item = document.createElement('li');
      item.className = 'gtj-taxonomy-filter__option';

      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'gtj-taxonomy-filter__checkbox';
      checkbox.id = `gtj-${config.key}-${normalize(taxonomyGroup.label).replace(/[^a-z0-9]+/g, '-')}-${Math.random().toString(36).slice(2, 8)}`;
      checkbox.checked = taxonomyGroup.values.some((value) => selected.indexOf(value) !== -1);
      checkbox.gtjTaxonomyValues = taxonomyGroup.values;

      const label = document.createElement('label');
      label.className = 'gtj-taxonomy-filter__label';
      label.htmlFor = checkbox.id;
      label.appendChild(checkbox);
      label.appendChild(document.createTextNode(taxonomyGroup.label));

      checkbox.addEventListener('change', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        applyTaxonomySelection(list, config);
      });

      item.appendChild(label);
      list.appendChild(item);
    });

    mount.appendChild(list);
    group.classList.add('gtj-taxonomy-filter-group', `gtj-taxonomy-filter-group--${config.key}`);
    group.gtjTaxonomyGroups = group.gtjTaxonomyGroups || {};
    group.gtjTaxonomyGroups[config.key] = groups;
    group.dataset[enhancedKey] = 'true';
    enhanceActiveTaxonomyTags(config, groups);
  }

  function enhanceTaxonomyFilters(root = document) {
    root.querySelectorAll('div.collection-sidebar__group, div[class^="collection-sidebar__group--"]').forEach((group) => {
      taxonomyFilters.forEach((config) => {
        if (group.querySelector(`input[name="${config.name}"]`)) buildTaxonomyFilter(group, config);
      });
    });
  }

  function hideSingleChoiceFilters(root = document) {
    root.querySelectorAll('div.collection-sidebar__group, div[class^="collection-sidebar__group--"]').forEach((shell) => {
      if (shell.classList.contains('gtj-gender-filter-group')) return;
      if (shell.querySelector('.price-range')) return;

      const customChoices = shell.querySelectorAll('.gtj-taxonomy-filter__checkbox');
      if (customChoices.length) {
        const hasActiveChoice = Array.from(customChoices).some((input) => input.checked);
        const shouldHide = !hasActiveChoice && customChoices.length < 2;
        shell.hidden = shouldHide;
        shell.classList.toggle('gtj-single-choice-filter-group', shouldHide);
        return;
      }

      const choices = Array.from(
        shell.querySelectorAll('input[type="checkbox"], input[type="radio"]')
      ).filter((input) => !input.disabled && !input.closest('.hide'));

      const uniqueChoices = new Set(choices.map((input) => `${input.name}|${input.value}`));
      const hasActiveChoice = choices.some((input) => input.checked);
      const shouldHide = !hasActiveChoice && uniqueChoices.size < 2;
      shell.hidden = shouldHide;
      shell.classList.toggle('gtj-single-choice-filter-group', shouldHide);
    });
  }

  let enhancementQueued = false;
  function enhance(root = document) {
    if (enhancementQueued) return;
    enhancementQueued = true;
    window.setTimeout(() => {
      enhancementQueued = false;
      hydrateHoverImages(root);
      hideRedundantFilters(root);
      enhanceTaxonomyFilters(root);
      hideSingleChoiceFilters(root);
    }, 0);
  }

  const start = () => {
    enhance(document);
    window.setTimeout(() => enhance(document), 150);
    window.setTimeout(() => enhance(document), 700);

    const ajaxContent = document.getElementById('CollectionAjaxContent');
    if (ajaxContent) {
      const observer = new MutationObserver(() => enhance(ajaxContent));
      observer.observe(ajaxContent, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  desktopHover.addEventListener?.('change', () => hydrateHoverImages(document));
})();
